import axios from "axios";
import { baseUrl, headers } from "../config/env";
/**
 * create(POST) / fetch(GET) / remove(DELETE) / update (PUT)
 *
 */
export function login(data) {
  return axios.post(baseUrl + "/admin/login", data, { headers });
}

export function fetchProfile() {
  return axios.get(baseUrl + `/accounts/profile`, { headers });
}

/** 본인 레벨 테스트 이력 (로그인 토큰 필요) */
export function fetchMyLevelTestSessions(params) {
  return axios.get(baseUrl + `/accounts/level-test/sessions`, {
    params,
    headers,
  });
}

/** 앱용 레벨 테스트 문제 목록·상세 (정답 미포함, 로그인 토큰 필요) */
export function fetchLevelTestProblemsPublic(params) {
  return axios.get(baseUrl + `/accounts/level-test/problems`, {
    params,
    headers,
  });
}

export function fetchLevelTestProblemPublic(id) {
  return axios.get(baseUrl + `/accounts/level-test/problems/${id}`, {
    headers,
  });
}

export function deleteUser(userId) {
  return axios.delete(baseUrl + `/admin/user/${userId}`, {
    headers,
  });
}
